import firebase from "firebase";
import axios from "axios";

//Helper function for quiz page, Takes in the assignment quiz number
//And returns an array of the assignment completion for the student's file.
//Used to mark green check marks on the assignment
export function CheckCompletion(classLevel, assignmentIndex){
    let promise = new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                let email = user.email;

                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
                studentFile.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        let studentData = res.data;
                        for (let i = 0; i < studentData.length; i++) {
                            if (studentData[i].email === email) {
                                if (studentData[i].assignmentCompletion[assignmentIndex]) {
                                    resolve(studentData[i].assignmentCompletion)
                                }
                            }
                        }
                    });


            }
        });
    })
    return promise;
}
